// import Rx from 'rxjs/Rx';
import {combineReducers, Reducer} from 'redux';
import {AppActions} from "./AppActions";
import {PageId} from "./Pages/PageId";
import {
    bannerInfoMessage,
    CustomColors,
    defaultColors,
    DropDownState,
    helpDialog,
    HelpDialogState,
    okCancelDialog,
    OKCancelDialogState,
    okDialog,
    OKDialogState,
    PledgerAction,
    PledgerAppComponentState,
    PledgerAppContext,
    StringUtils,
    wsError,
    WSError
} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {pageId, pageManager} from "../../services/ui/AppPageManager";
import {FooterType} from "./FooterType";
import {WServiceActions} from "../../services/ws/WServiceActions";
import {changePasswordWServiceActions} from "../../services/ws/changePassword/changePasswordWServiceActions";
import {changeEmailWServiceActions} from "../../services/ws/changeEmail/changeEmailWServiceActions";
import {navigationMenu, NavigationMenuState} from "../../services/ui/NavigationMenu/NavigationMenuReducers";


export interface URLNavigatorState {
    url? : string;
    replace? : boolean;
}

export interface URLNavigatePayload {
    url : string;
    replace : boolean;
}

const urlNavigator = (state= {}, action : PledgerAction<URLNavigatePayload>) => {
    let result : URLNavigatorState;

    switch (action.type) {
        case AppActions.NAVIGATE_URL.type:
            result = { url: action.payload?.url,replace:action.payload?.replace };
            break;

        default:
            result = state;
    }
    return result;
};
const isPhone = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case AppActions.MATCH_MEDIA_ACTION.type:
            return action.payload.isPhone;

        default:
            return state;

    }
};

const zoomPercent = (state = '100%', action : PledgerAction) => {
    switch (action.type) {
        case AppActions.MATCH_MEDIA_ACTION.type:
            return action.payload.zoomPercent;
        default:
            return state;
    }
};

const zoomFactor = (state = 1.0, action : PledgerAction) => {
    switch (action.type) {
        case AppActions.MATCH_MEDIA_ACTION.type:
            return action.payload.zoomFactor;
        default:
            return state;
    }
};



const currentPage  = (state: PledgerPageComponentState = {pageId:PageId.NONE,breadCrumbEnabled:false, footerType: FooterType.NONE}, action : PledgerAction) => {

    let newState : PledgerPageComponentState;

    let newPageId = pageId(state.pageId!==undefined ? state.pageId : PageId.NONE,action);

    // si la page a changé, on vire les données en cours
    if (newPageId!==state.pageId) {
        newState = {
            pageId : newPageId,
            breadCrumbEnabled:false,
            footerType: FooterType.NONE
        }
    }
    else {
        newState = {
            ...state,
            pageId : newPageId,
            breadCrumbEnabled:false,
            footerType: FooterType.NONE
        }
    }

    let pageState;

    const pageReducer = pageManager.getPageReducers(newState.pageId);
    if (pageReducer) {
        pageState = pageReducer(newState, action);
    }
    else {
        pageState = newState;
    }

    return {
        ...newState,
        ...pageState
    };

};

const dropDownStates = (state  : any = {}, action : PledgerAction) => {
    switch (action.type) {
        case AppActions.TOGGLE_DROPDOWN_ACTION.type:
            const dropdownId = action.payload.dropdownId;
            let newState = {...state};
            let dropDownState: DropDownState = {...(state[dropdownId] ?? {isOpen: false})};
            dropDownState.isOpen = !dropDownState.isOpen;
            if (dropDownState.isOpen) {
                newState={};
            }
            newState[dropdownId] = dropDownState;
            return newState;

        case AppActions.CLOSE_ALL_DROPDOWN_ACTION.type:
            return {};

        default:
            return state;
    }
};

const isLightVersion = (state = false, action: PledgerAction) => {
    return state;
};

const enrollmentToken = (state = '', action : PledgerAction) => {
    let newState=state;

    if (newState==='') {
        newState=sessionStorage.getItem('enrollmentToken') ?? '';
    }

    if (newState===null) {
        newState='';
    }

    switch (action.type) {
        case WServiceActions.GET_ENROLLMENT_TOKEN_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.token) {
                newState=action.payload.data.token;
                sessionStorage.setItem('enrollmentToken',newState);
            }
            return newState;


        case WServiceActions.GET_ENROLLMENT_TOKEN_FAILED_ACTION.type:
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            newState='';
            sessionStorage.removeItem('enrollmentToken');
            return newState;

        default:
            return newState;
    }
};

const userToken = (state = '', action : PledgerAction) => {
    let newState=state;

    if (newState==='') {
        newState=sessionStorage.getItem('userToken') ?? '';
    }

    if (newState===null) {
        newState='';
    }

    switch (action.type) {
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.userToken) {
                newState=action.payload.data.userToken;
                sessionStorage.setItem('userToken',newState);
            }
            return newState;

        case WServiceActions.CREATE_ACCOUNT_FAILED_ACTION.type:
            newState='';
            sessionStorage.removeItem('userToken');
            return newState;

        case WServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.token) {
                newState=action.payload.data.token;
                sessionStorage.setItem('userToken',newState);
            }
            return newState;

        case AppActions.DISCONNECT_ACTION.type:
            newState='';
            sessionStorage.removeItem('userToken');
            return newState;

        case changePasswordWServiceActions.CHANGE_PASSWORD_POST_PASSWORD_VALIDATION_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.token) {
                newState=action.payload.data.token;
                sessionStorage.setItem('userToken',newState);
            }
            return newState;

        case changeEmailWServiceActions.CHANGE_EMAIL_PUT_NEW_MAIL_VALIDATION_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.token) {
                newState=action.payload.data.token;
                sessionStorage.setItem('userToken',newState);
            }
            return newState;

        default:
            return newState;
    }
};

const isMIOBSP = (state = false, action : PledgerAction) => {
    let newState=state;

    if (newState===false) {
        newState=('true'===sessionStorage.getItem('isMIOBSP') ?? 'false');
    }

    if (newState===null) {
        newState=false;
    }

    switch (action.type) {
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.isMIOBSP) {
                newState=action.payload.data.isMIOBSP;
                sessionStorage.setItem('isMIOBSP',newState ? 'true' : 'false');
            }
            return newState;

        case WServiceActions.CREATE_ACCOUNT_FAILED_ACTION.type:
            newState=false;
            sessionStorage.removeItem('isMIOBSP');
            return newState;

        case WServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_POST_OTP_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.isMIOBSP) {
                newState=action.payload.data.isMIOBSP;
                sessionStorage.setItem('isMIOBSP',newState ? 'true' : 'false');
            }
            return newState;

        case AppActions.DISCONNECT_ACTION.type:
            newState=false;
            sessionStorage.removeItem('isMIOBSP');
            return newState;

        default:
            return newState;
    }
};

const userScopes = (state : string[] = [], action : PledgerAction) => {
    let newState = state;

    if (newState.length === 0) {
        const jsonState = sessionStorage.getItem('userScopes') ?? '';
        if (jsonState !== null && jsonState !== '') {
            newState = JSON.parse(jsonState);
        }
    }

    if (newState === null) {
        newState = [];
    }

    switch (action.type) {
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            if (undefined !== action.payload.data.userScopes) {
                newState = action.payload.data.userScopes;
                sessionStorage.setItem('userScopes', JSON.stringify(newState));
            }
            return newState;

        case WServiceActions.CREATE_ACCOUNT_FAILED_ACTION.type:
            newState = [];
            sessionStorage.removeItem('userScopes');
            return newState;

        case WServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_SUCCEEDED_ACTION.type:
            if (undefined !== action.payload.data.userScopes) {
                newState = action.payload.data.userScopes;
                sessionStorage.setItem('userScopes', JSON.stringify(newState));
            }
            return newState;

        case WServiceActions.LOGIN_POST_OTP_SUCCEEDED_ACTION.type:
            if (undefined !== action.payload.data.userScopes) {
                newState = action.payload.data.userScopes;
                sessionStorage.setItem('userScopes', JSON.stringify(newState));
            }
            return newState;

        case AppActions.DISCONNECT_ACTION.type:
            newState = [];
            sessionStorage.removeItem('userScopes');
            return newState;


        default:
            return newState;
    }
};

const userFirstName = (state = '', action : PledgerAction) => {
    let newState=state;

    if (newState==='') {
        newState=sessionStorage.getItem('userFirstName') ?? '';
    }

    if (newState===null) {
        newState='';
    }

    switch (action.type) {
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.profile?.identite?.firstName) {
                newState=StringUtils.capitalize(action.payload.data.profile.identite.firstName);
                sessionStorage.setItem('userFirstName',newState);
            }
            return newState;

        case WServiceActions.CREATE_ACCOUNT_FAILED_ACTION.type:
            newState='';
            sessionStorage.removeItem('userFirstName');
            return newState;

        case WServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.profile?.identite?.firstName) {
                newState=StringUtils.capitalize(action.payload.data.profile.identite.firstName);
                sessionStorage.setItem('userFirstName',newState);
            }
            return newState;

        case WServiceActions.LOGIN_POST_OTP_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.profile.identite.firstName) {
                newState=StringUtils.capitalize(action.payload.data.profile.identite.firstName);
                sessionStorage.setItem('userFirstName',newState);
            }
            return newState;

        case AppActions.DISCONNECT_ACTION.type:
            newState='';
            sessionStorage.removeItem('userFirstName');
            return newState;

        default:
            return newState;
    }
};

const userLastName = (state = '', action : PledgerAction) => {
    let newState=state;

    if (newState==='') {
        newState=sessionStorage.getItem('userLastName') ?? '';
    }

    if (newState===null) {
        newState='';
    }

    switch (action.type) {
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.profile?.identite?.lastName) {
                newState=StringUtils.capitalize(action.payload.data.profile.identite.lastName);
                sessionStorage.setItem('userLastName',newState);
            }
            return newState;

        case WServiceActions.CREATE_ACCOUNT_FAILED_ACTION.type:
            newState='';
            sessionStorage.removeItem('userLastName');
            return newState;

        case WServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.profile?.identite?.lastName) {
                newState=StringUtils.capitalize(action.payload.data.profile.identite.lastName);
                sessionStorage.setItem('userLastName',newState);
            }
            return newState;

        case WServiceActions.LOGIN_POST_OTP_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.profile?.identite?.lastName) {
                newState=StringUtils.capitalize(action.payload.data.profile.identite.lastName);
                sessionStorage.setItem('userLastName',newState);
            }
            return newState;

        case AppActions.DISCONNECT_ACTION.type:
            newState='';
            sessionStorage.removeItem('userLastName');
            return newState;

        default:
            return newState;
    }
};

const userPartnerName = (state = '', action : PledgerAction) => {
    let newState=state;

    if (newState==='') {
        newState=sessionStorage.getItem('userPartnerName') ?? '';
    }

    if (newState===null) {
        newState='';
    }

    switch (action.type) {
        case WServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.partnerName) {
                newState=action.payload.data.partnerName;
                sessionStorage.setItem('userPartnerName',newState);
            }
            return newState;

        case WServiceActions.CREATE_ACCOUNT_FAILED_ACTION.type:
            newState='';
            sessionStorage.removeItem('userPartnerName');
            return newState;

        case WServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type:
        case WServiceActions.LOGIN_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.partnerName) {
                newState=action.payload.data.partnerName;
                sessionStorage.setItem('userPartnerName',newState);
            }
            return newState;

        case WServiceActions.LOGIN_POST_OTP_SUCCEEDED_ACTION.type:
            if(undefined !== action.payload.data.partnerName) {
                newState=action.payload.data.partnerName;
                sessionStorage.setItem('userPartnerName',newState);
            }
            return newState;

        case AppActions.DISCONNECT_ACTION.type:
            newState='';
            sessionStorage.removeItem('userPartnerName');
            return newState;

        default:
            return newState;
    }
};


const burgerMenuOpen = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case AppActions.OPEN_BURGER_MENU_ICON_ACTION.type:
            return true;

        case AppActions.CLOSE_BURGER_MENU_ICON_ACTION.type:
            return false;

        default:
            return state;
    }
};

const customColors = (state : CustomColors = defaultColors, action : PledgerAction) => {
    return state;
};

export interface AppContext extends PledgerAppContext {
    pageId: PageId;
    wsError: WSError;
    bannerInfoMessage: string;
    isPhone: boolean;
    isLightVersion: boolean;
    zoomPercent:string;
    zoomFactor:number;
    enrollmentToken: string;
    userToken: string;
    isMIOBSP: boolean;
    userScopes:string[];
    userFirstName: string;
    userLastName: string;
    userPartnerName: string;
    burgerMenuOpen: boolean;
    customColors:CustomColors;

};

const appContext : Reducer<AppContext> = combineReducers({
    pageId,         // identifiant de la page courante
    wsError,
    bannerInfoMessage,
    isPhone,
    isLightVersion,
    zoomPercent,
    zoomFactor,
    enrollmentToken,
    userToken,
    isMIOBSP,
    userScopes,
    userFirstName,
    userLastName,
    userPartnerName,
    burgerMenuOpen,
    customColors
});

export interface AppComponentState extends PledgerAppComponentState<PageId> {
    appContext: AppContext;
    currentPage : PledgerPageComponentState;
    okCancelDialog: OKCancelDialogState;
    okDialog: OKDialogState;
    helpDialog: HelpDialogState;
    urlNavigator: URLNavigatorState;
    dropDownStates:any;
    navigationMenu: NavigationMenuState;
};

export const appReducer : Reducer = combineReducers({
    appContext,
    currentPage,    // page courante
    okCancelDialog,
    okDialog,
    helpDialog,
    urlNavigator,
    dropDownStates,
    navigationMenu
});



